import { WifiOff } from "lucide-react";
import { useOnline } from "@/lib/offline";

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="bg-amber-400 text-slate-900 text-sm font-bold print:hidden" data-testid="offline-banner">
      <div className="max-w-3xl mx-auto px-4 py-2 flex items-center gap-2">
        <WifiOff className="w-4 h-4" /> Hors ligne : vos dernières leçons restent disponibles
      </div>
    </div>
  );
}
